import { useBackendData } from 'services/useBackendData';

import { itemService } from './itemService';

export const useAuctionData = (itemId?: number, isAuction?: boolean) =>
  useBackendData(itemService.fetchAuction, itemId, {
    fetchIf: isAuction,
  });
